import isMobile from 'ismobilejs'


export default (theme) => ({
    paper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop:'65px'
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    textoLogin:{
        textAlign: 'center',
        fontSize: '20px',
        fontWeight: '700',
        margin: '18px 0 18px 0'
    },
    textoForm:{
        marginBottom: '10px'
    },
    boldText:{
        fontWeight: '700'
    },
    gridVerification:{
        margin: '35px 0 15px 0'
    },
    firstText:{
        marginTop: '15px',
        fontSize: '15px'
    },
    aaLoaderModal: {
        height: isMobile.any ? '100vh' : '70vh' ,
        width: isMobile.any ? '100%' : '350px',
        display: 'grid',
        justifyContent: 'center',
        alignContent: 'center'
      },
      aaLoader:{
        height: '100vh',
        display: 'grid',
        justifyContent: 'center',
        alignContent: 'center'
      },
    verficationContainer:{
        "& .ReactInputVerificationCode__container": {
         width: isMobile.any ? '320px' : '400px',
         gap: '10px',
         fontFamily:'UniNeue',
         fontWeight: '800'
        },
        "& .ReactInputVerificationCode__input": {
            position: 'fixed'
        },
        margin: '35px 0 35px 0',
    },
    verificationFail: {
        marginTop: '4px',
        color:'red',
    },
})